import {
  BaseGroup,
  Group,
  GroupPermission,
  GroupWithPermissions,
  Permission,
  UpdateValues,
} from './models/group';
import { User } from './models/user';
import { Common } from './common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(): Promise<Group[]> {
    const url = this.common.constructPath('/groups');
    return this.common.getJSON(url);
  }

  async findAllPermissions(): Promise<Permission[]> {
    const url = this.common.constructPath('/groups/permissions');
    return this.common.getJSON(url);
  }

  async findAllWithPermissions(): Promise<GroupWithPermissions[]> {
    const url = this.common.constructPath('/groups', {
      withPermissions: true,
    });
    return this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<Group> {
    const url = this.common.constructPath(`/groups/${id}`);
    return this.common.getJSON(url);
  }

  async findOneWithPermissionsById(id: string): Promise<GroupWithPermissions> {
    const url = this.common.constructPath(`/groups/${id}`, {
      withPermissions: true,
    });
    return this.common.getJSON(url);
  }

  async create(toAdd: BaseGroup): Promise<Group> {
    const url = this.common.constructPath('/groups');
    return this.common.postJSON(url, toAdd);
  }

  async update(id: string, toUpdate: UpdateValues): Promise<Group> {
    const url = this.common.constructPath(`/groups/${id}`);
    return this.common.patchJSON(url, toUpdate);
  }

  async remove(id: string): Promise<boolean> {
    const url = this.common.constructPath(`/groups/${id}`);
    const { success } = await this.common.deleteJSON(url);
    return success;
  }

  async findAllUsers(groupId: string): Promise<User[]> {
    const url = this.common.constructPath(`/groups/${groupId}/users`);
    return this.common.getJSON(url);
  }

  async createPermission(
    groupId: string,
    permission: Permission,
  ): Promise<GroupPermission> {
    const url = this.common.constructPath(`/groups/${groupId}/permissions`);
    return this.common.postJSON(url, { name: permission });
  }

  async removePermission(groupId: string, permissionId: string): Promise<void> {
    const url = this.common.constructPath(
      `/groups/${groupId}/permissions/${permissionId}`,
    );
    const { success } = await this.common.deleteJSON(url);
    return success;
  }
}
